import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { from } from 'rxjs';
import { HttpClient } from '@angular/common/http'
// Services
import { environment } from '../../../environments/environment';
import { LocationService } from '../../services/location.service';
import { CustomPageService } from '../../services/custom-page.service';
import { GlobalFlagsService } from '../../services/global-flags.service';
import { OAuthService } from '../../services/oauth.service';
import { DialogService } from '../../services/dialog.service';
import { RegistrationService } from '../../services/registration.service';
import { StorageService } from '../../services/storage.service';
import { ModuleService } from '../../services/modules.service';
import { CookieService } from 'ngx-cookie';
import { FormService } from '../../services/forms.service';
import { RequestHistoryService } from '../../services/requestHistory.service';

import { FormBuilder, FormGroup } from '@angular/forms';
import { UserFormActions } from '../user/user-form-actions';
import { UserForm } from '../../models/UserForm';
import { TranslateService } from '@ngx-translate/core';

import * as moment from 'moment';

@Component({
  selector: 'app-download-report',
  templateUrl: './download-report.component.html',
  styleUrls: ['./download-report.component.scss']
})


export class DownloadReportComponent implements OnInit {

_dobValid: boolean = false;
  get dobValid() {
    return this._dobValid;
  }
  set dobValid(value: boolean) {
    this._dobValid = value;
  }

  constructor(private route: ActivatedRoute,
    private router: Router,
	  private registrationService: RegistrationService,
    private locationService: LocationService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private customPageService: CustomPageService,
    private globalFlagsService: GlobalFlagsService,
    private oAuthService: OAuthService,
    private storageService: StorageService,
    private dialogService: DialogService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private moduleService: ModuleService,
    private formService: FormService,
    private requestService: RequestHistoryService,
    private http: HttpClient) {
    this.translate.addLangs(['EN', 'FR', 'UR', 'ES', 'IT', 'FA', 'DE', 'ZH-CHS']);
        this.translate.setDefaultLang('EN');
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang.match(/EN|FR|UR|ES|IT|FA|DE|ZH-CHS/) ? browserLang : 'EN');
  }

//   @ViewChild(StartSurveyComponent)
//   public startSurveyComponent: StartSurveyComponent;

  viewObj = {
    htmlContent: null,
    name: null
  };

  token = null;
  customTextVerification = null;

  invalidAccess;

  action = UserFormActions.Register;
  userDetails: UserForm = new UserForm();

  formCreated = false;

  languages: any;
  language: any;
  multipleLanguage: any;
  languageId: number = 1;


  editUserForm: FormGroup;

  private sub;
  private res;

  birthDate = {
    day: null,
    month: null,
    year: null
  };
  yearsArr = Array();
  monthsArr = moment.months();
  daysArr = Array();

  isFieldInvalid(field: any) {
    const fieldFlags = this.editUserForm.get(field);
    return (fieldFlags.invalid && (fieldFlags.dirty || fieldFlags.touched));
  }


  ngOnInit() {
    this.oAuthService.logout();
    let er;
    this.globalFlagsService.displayLoad(true);


    this.sub = this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      const obj = {
        'token': this.token
      };
      this.validateToken(obj);
	    this.populateDatesArr();
    });
  }

  getLabel() {
    return 'Enter your date of birth'
  }


  validateToken(obj : any) {
    const confirmation = from(this.registrationService.checkIsValidTokenInstanceForDownload(obj));
    confirmation
      .subscribe(
        (res: any) => {
          if (res) {
            this.globalFlagsService.displayLoad(false);
            this.oAuthService.saveDownloadToken(obj);
          }
          this.cookieService.put('formLanguage', '1');
          this.languageId = Number(this.cookieService.get('formLanguage'));
        },
        (err) => {
          let message = 'Could not open pdf file, token might have expired.'
          this.dialogService.openErrorDialogRedirectLogin({message});
        }
      );
  }

  populateDatesArr() {
    const firstYear = 1900;
    const actualYear = moment().year();
    for (let i = firstYear; i <= actualYear; i++) {
      this.yearsArr.push(i);
    }
    this.yearsArr = this.yearsArr.sort((a, b) => a > b ? -1 : 1);
    this.daysArr = Array(31).fill(0).map((e, i) => i + 1);

  }


 // Validates Dob of the patient that is accessing with download Token.
  onClickDate() {
    const month = moment().month(this.birthDate.month).format('M');

    const obj = {
      'token': this.token,
      'dateOfBirth': `${month}/${this.birthDate.day}/${this.birthDate.year}`
    };

    this.globalFlagsService.displayLoad(true);

    const confirmation = from(this.registrationService.confirmDobDownloadFile(obj));
    confirmation
      .subscribe((res: any) => {
        if (res != null) {
          this.dobValid = true;
          let prefix = `${environment.url.api}`;
          this.http.get(prefix + 'api/forms/generatePDF/'+res, { responseType: "text" })
          .subscribe((url) => {
            if (url) {
              console.log(url);
              let downloadURL = this.convertUrlToString(url);
              this.requestService.downloadPDFFromSMS(downloadURL+'.pdf/'+this.token, 'PDF');
            }
          },
          (err) => {
            console.log(err);
          });
        }
          else {
            this.dobValid = false;
            const message = 'Incorrect date of birth. Please try again.';
            this.dialogService.openErrorDialog({ message });
          }
      });
  }

  convertUrlToString (url) {
    let result = "";
    Object.keys(url).forEach(k => {
      result += url[k];
    });

    return result;
  }

  changeLanguage() {
    this.cookieService.put('formLanguage', this.languageId.toString());
    OAuthService.saveLanguage(this.languageId);
    switch (this.languageId) {
      case 1:
        OAuthService.saveLanguageCode('EN');
        break;
      case 2:
        OAuthService.saveLanguageCode('ES');
        break;
      case 3:
        OAuthService.saveLanguageCode('ZH');
        break;
      case 4:
        OAuthService.saveLanguageCode('AR');
        break;
      case 5:
        OAuthService.saveLanguageCode('RU');
        break;
      case 6:
        OAuthService.saveLanguageCode('PL');
        break;
      case 7:
        OAuthService.saveLanguageCode('KO');
        break;
      default:
        OAuthService.saveLanguageCode('EN');
        break;
    }
    this.translate.use(OAuthService.getLanguageCode());
    localStorage.setItem('lang', this.languageId.toString());
  }

  get changedLanguage() {
    return Number(localStorage.getItem('changedLanguage'));
  }

}
